export enum EnabledModulesEnum {
  SIGNATURE = 'SIGNATURE',
  FEA = 'FEA',
  VALIDATION = 'VALIDATION',
  TIMESTAMP = 'TIMESTAMP',
  ENCRYPTION = 'ENCRYPTION',
  FILESYSTEM = 'FILESYSTEM'
}
